import type { HumanProportions } from './human.js';

/** Muscle volume grows the anatomical envelope the skin, garments and armor share, keeping joint lengths fixed. */
export function muscularProportions(source: HumanProportions): HumanProportions {
  const mass = Math.max(0, Math.min(1, source.muscularity));
  if (mass === 0) return source;
  const p = { ...source };
  p.shoulderHalfWidth += .027 * mass; p.chestHalfWidth += .028 * mass; p.ribHalfWidth += .009 * mass;
  p.waistHalfWidth += .004 * mass; p.pelvisDepth += .006 * mass;
  p.neckRadius += .008 * mass; p.handScale *= 1 + .045 * mass; p.thighFullness *= 1 + .09 * mass;
  // Gluteal and adductor mass: a fuller seat and inner thigh.
  p.glute += .008 * mass; p.pelvisShape = { ...source.pelvisShape, innerThigh: source.pelvisShape.innerThigh + .004 * mass };
  const front = [0, .003, .004, .003, .005, .014, .018, .012, .009, .007, .004, .003, .002];
  const back = [0, .004, .006, .004, .008, .014, .016, .018, .014, .009, .006, .004, .003];
  p.trunk = { front: source.trunk.front.map((v, i) => v + front[i] * mass), back: source.trunk.back.map((v, i) => v + back[i] * mass) };
  p.neck = { front: source.neck.front.map(v => v + .005 * mass), back: source.neck.back.map(v => v + .007 * mass) };
  p.headCacheKey = `${source.headCacheKey ?? source.id}:muscle:${mass}`;
  return p;
}
